<template>
  <layout-basic>
    <v-row class="Background">
      <v-col md="12">
        <v-card flat class="text-right v-card-bg-none">
          <v-card-actions>
            <v-btn
              color="secondary"
              outlined
              class="mr-1"
              :to="'/courses/player/' + id"
            >
              <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to Course
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-container fluid class="text-left">
      <v-row>
        <div class="ma-8">
          <v-data-table
            :headers="headers"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            :loading="loading"
            :items="logs"
          >
            <template v-slot:item.id="{ item }">
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      color="secondary"
                      class="ml-1"
                      @click="getAnswerLog(item.id)"
                      text
                      small
                    >
                      <v-icon small>fa-list-ul</v-icon>
                    </v-btn>
                  </template>
                  <span>See detail</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import testAPI from '@/api/test.js';
import { EventBus } from '@/event-bus.js';
import Result from '@/components/authenticated/courses/Result';
export default {
  name: 'ActivityWidget',
  components: {
    LayoutBasic,
  },
  data() {
    return {
      headers: [
        {
          text: 'Attempted Date',
          value: 'created_date_formatted',
          sortable: false,
        },
        {
          text: '',
          value: 'id',
          sortable: false,
          align: 'end',
        },
      ],
      logs: [],
      loading: false,
      pagination: {},
      options: {},
      id: this.$route.params.id,
    };
  },
  props: {
    total_courses: {
      type: Number,
      default: 0,
    },
    total_in_progress_courses: {
      type: Number,
      default: 0,
    },
    total_completed_courses: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },

    total: function () {
      return this.total_courses;
    },
    series: function () {
      return [
        this.notStartedPercentage,
        this.inProgessPercentage,
        this.completedPercentage,
      ];
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourseTestLogs();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    getAnswerLog(id) {
      this.$showPanel({
        component: Result,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    setEventBus() {
      EventBus.$on('ANSWERS_SUBMITTED', (payload) => {
        this.getCourseTestLogs();
      });
    },
    generatePDF(url) {
      if (url != null) {
        window.open(url, '_blank');
      }
    },
    getCourseTestLogs() {
      this.loading = true;
      testAPI.getCourseTestLog(this.id, this.params).then((resp) => {
        this.logs = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
  },
};
</script>
<style>
.completed {
  color: #ffaf19;
}
.inprogress {
  color: #00e396;
}
.notstarted {
  color: #008efb;
}
</style>
